import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-zinc-900" data-id="element-186">
      <div className="container mx-auto px-4" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-189">
            🛒 ELEGÍ TU MEGA PACK
          </h2>
          <p className="text-zinc-200 text-[16px]" data-id="element-190">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-191">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-black/80 rounded-3xl p-8 shadow-2xl border border-violet-900/40 flex flex-col h-full" data-id="element-192">
            <div className="mb-6" data-id="element-193">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-194">
                🌸 MEGA PACK EMPRENDEDORA
              </h3>
              <p className="text-violet-300 font-bold" data-id="element-195">6 Tomos + 4 Bonus</p>
            </div>

            <div className="mb-6 pb-6 border-b border-violet-900/30" data-id="element-196"></div>

            <div className="mb-8" data-id="element-197">
              <div className="flex items-end gap-2" data-id="element-198">
                <span className="text-5xl font-black text-white" data-id="element-199">$19.990</span>
                <span className="text-xl font-bold text-violet-300 mb-1" data-id="element-200">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-201">
              {['6 Tomos completos (Contenido → Mentalidad)', '4 Bonus estratégicos', '500+ páginas de sistema completo', 'Pack de Frases + Reels + WhatsApp + IA', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-202">
                  <Check className="w-5 h-5 text-violet-400 shrink-0 mt-0.5" data-id="element-203" />
                  <span className="text-zinc-100" data-id="element-204">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53656189600062:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-205">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-206">
                🔥 QUIERO MI MEGA PACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-black rounded-3xl p-8 shadow-2xl border-2 border-violet-400 flex flex-col h-full relative lg:scale-105 z-10" data-id="element-207">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-violet-400 text-black px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-208">
              <Star className="w-4 h-4 fill-black" data-id="element-209" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-210">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-211">
                ⚡ MEGA PACK EMPRENDEDORA + SISTEMA PRO
              </h3>
              <p className="text-violet-400 font-bold text-[14px]" data-id="element-212">
                6 Tomos + 4 Bonus + Sistema Avanzado de Ventas y Estrategia
                Digital
              </p>
              <p className="text-zinc-400 text-sm mt-1" data-id="element-213">
                (ventas avanzadas, estrategia de crecimiento y CRM básico para
                emprendedoras)
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-violet-900/30" data-id="element-214"></div>

            <div className="mb-8" data-id="element-215">
              <div className="flex items-end gap-2" data-id="element-216">
                <span className="text-5xl font-black text-white" data-id="element-217">$27.990</span>
                <span className="text-xl font-bold text-zinc-400 mb-1" data-id="element-218">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-219">
              <li className="flex items-start gap-3" data-id="element-220">
                <Check className="w-5 h-5 text-violet-400 shrink-0 mt-0.5" data-id="element-221" />
                <span className="text-white font-bold" data-id="element-222">
                  Todo lo del Mega Pack Emprendedora, MÁS:
                </span>
              </li>
              {['Tomo Pro 1 — Estrategia de ventas avanzada (funnel, conversión y seguimiento)', 'Tomo Pro 2 — Crecimiento orgánico acelerado en Instagram', 'Tomo Pro 3 — Guía de colaboraciones y alianzas estratégicas', 'Tracker Pro en Excel con dashboard de ventas, seguimiento de clientes y métricas clave', 'Bonus Pro 1 — Guía de publicidad en Meta para emprendedoras (sin agencia)', 'Bonus Pro 2 — Plantilla de CRM básico para gestionar clientes y seguimiento', 'Bonus Pro 3 — Base de datos de fechas especiales argentinas con ideas de contenido por fecha'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-223">
                  <Check className="w-5 h-5 text-violet-400 shrink-0 mt-0.5" data-id="element-224" />
                  <span className="text-zinc-300" data-id="element-225">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53656191271230:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-226">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-227">
                ⚡ QUIERO EL MEGA PACK + SISTEMA PRO
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}